var _excluded = ["className", "id", "isDisabled", "isSelected", "name"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import cs from 'classnames';
import { needsLegacyImgSupport } from '../image';
require("./color-swatch.css");
var styles = {
  "colorSwatch": "colorSwatch-2yqfi",
  "colorSwatchImg": "colorSwatchImg-2mYJB",
  "colorSwatchPicture": "colorSwatchPicture-KEE-O",
  "colorSwatchImgWrapper": "colorSwatchImgWrapper-1k4IP",
  "colorSwatchActive": "colorSwatchActive-3hOqb",
  "colorSwatchDisabled": "colorSwatchDisabled-3BcfS"
};
var ColorSwatch = _ref => {
  var {
      className,
      id,
      isDisabled,
      isSelected,
      name
    } = _ref,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var src = "https://images.lululemon.com/is/image/lululemon/".concat(id);
  var [imgFallback, setImgFallback] = useState('data:,');
  useEffect(() => {
    if (needsLegacyImgSupport()) {
      setImgFallback("".concat(src, "?wid=34&hei=34&fit=crop,1&op_usm=0.5,2,10,0&fmt=jpeg&qlt=75,1&op_sharpen=0&resMode=sharp2&iccEmbed=0&printRes=72"));
    }
  }, [src]);
  var altTxt = "".concat(name).concat(isDisabled ? ' (not available)' : '');
  var scene7APISrcSet = _ref2 => {
    var {
      baseImageUrl,
      format
    } = _ref2;
    var baseScene7QueryParams = "fmt=".concat(format || 'jpeg', "&qlt=").concat(format === 'webp' ? '90' : '75', ",1&op_sharpen=0&resMode=sharp2&iccEmbed=0&printRes=72");
    var unsharpMask1x = '0.8,1,10,0';
    var scene7ImageWidths = [{
      width: 34
    },
    // regular 1x
    {
      width: 68
    } // retina 2x
    ];

    var constructSrcSetString = imageWidths => {
      return imageWidths.map(_ref3 => {
        var {
          width
        } = _ref3;
        return "".concat(baseImageUrl, "?wid=").concat(width, "&hei=").concat(width, "&fit=crop,1&op_usm=").concat(unsharpMask1x, "&").concat(baseScene7QueryParams, " ").concat(width, "w");
      }).join(',\n');
    };
    return constructSrcSetString(scene7ImageWidths);
  };
  var sources = ['webp', 'jpeg'].map(format => /*#__PURE__*/React.createElement("source", {
    key: format,
    sizes: "34px",
    srcSet: scene7APISrcSet({
      baseImageUrl: src,
      format
    }),
    type: "image/".concat(format)
  }));
  return /*#__PURE__*/React.createElement("span", {
    className: cs(styles.colorSwatch, {
      [styles.colorSwatchActive]: isSelected,
      [styles.colorSwatchDisabled]: isDisabled,
      [className]: className
    })
  }, /*#__PURE__*/React.createElement("span", {
    className: styles.colorSwatchImgWrapper
  }, /*#__PURE__*/React.createElement("picture", {
    className: styles.colorSwatchPicture
  }, sources, /*#__PURE__*/React.createElement("img", _extends({
    alt: altTxt,
    className: styles.colorSwatchImg,
    sizes: "34px",
    src: imgFallback,
    srcSet: scene7APISrcSet({
      baseImageUrl: src
    }),
    title: altTxt
  }, otherProps)))));
};
ColorSwatch.propTypes = {
  className: PropTypes.string,
  /** Color ID, used to generate the color swatch image URL */
  id: PropTypes.string.isRequired,
  /** Whether to show in a disabled state */
  isDisabled: PropTypes.bool,
  /** Whether to show in a selected state */
  isSelected: PropTypes.bool,
  /** Color name, used as alternative text for screen readers */
  name: PropTypes.string
};
ColorSwatch.defaultProps = {
  className: '',
  isDisabled: false,
  isSelected: false,
  name: ''
};
export default ColorSwatch;